var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockSolid = function SvgLockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.25a3.5 3.5 0 0 0-3.5 3.5v1.56a97 97 0 0 1 3.5-.06 97 97 0 0 1 3.5.06V6.75a3.5 3.5 0 0 0-3.5-3.5m-5.5 3.5v1.777a4.3 4.3 0 0 0-2.975 3.528c-.149 1.1-.275 2.257-.275 3.445s.126 2.344.275 3.445c.271 2.017 1.942 3.61 4 3.705 1.429.066 2.88.1 4.475.1 1.596 0 3.046-.034 4.475-.1 2.058-.095 3.729-1.688 4-3.705.149-1.1.275-2.257.275-3.445s-.126-2.344-.274-3.445A4.3 4.3 0 0 0 17.5 8.527V6.75a5.5 5.5 0 1 0-11 0M17 15.49a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0zm-5-1a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1m-3 1a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgLockSolid;